import { Language } from '../../drupal/types_and_parser/types.ext.gen'

/*
 * All Drupal URLs will be prefixed with a Language code
 * This code must be replace by the current Region or Locale code
 */
export const updateUrlLang = (url: string, newLang: string): string => {
  if (url.startsWith('/')) {
    url = url.slice(1)
  }
  const path = url.split('/').slice(1).join('/')

  // If the requested language is the default language, we'll leave the url untouched
  return `/${newLang}/${path}`
}

export const languages: Array<{ IsDefault: boolean; Value: Language }> = window['languages']

export const defaultLanguage: Language = languages.find((x) => x.IsDefault == true)?.Value || 'en'

export const getLangFromUrl = (): Language => {
  let pathLanguage: string = defaultLanguage
  if (window.location.pathname != '/') {
    const pathSplit = window.location.pathname.split('/')
    if (pathSplit.length > 1) pathLanguage = pathSplit[1]
  }
  return languages.find((language) => language.Value == pathLanguage)?.Value || defaultLanguage
}
